import { CLOSE_MEGAMENU } from 'redux/modules/mega-menu/actions/types';

export default () => ({
  type: CLOSE_MEGAMENU,
});
